/* eslint-disable */
/*
 * First level chats (with / without context of the patient),
 * containing nested channels within the context of the patient
 */
import uniqBy from 'lodash/uniqBy';
import { has, get, omit } from 'lodash';
import createConsts from '../../utils/redux/consts';
import { createActions } from '../../utils/redux';
import { consts as chatConsts } from '../chatConnection';

const supportedActions = ['GET_ITEMS', 'ADD_ITEMS', 'CLEAR', 'CHANGE_STATUS'];

export const consts = createConsts('board', 'channels', ...supportedActions);
export const actions = createActions(consts);

const initialState = [];

const formatChannels = list => {
  const contextUsers = uniqBy(list, 'contextUser.id').filter(
    item => item.contextUser,
  );
  const contextChannels = uniqBy(list, 'contextChannel.channelId').filter(
    item => item.contextChannel,
  );
  return [...contextUsers, ...contextChannels];
};

const addChannels = (state, action) => {
  const updatedList = Array.isArray(action.payload)
    ? [...state, ...action.payload]
    : [action.payload, ...state];
  return formatChannels(updatedList);
};

const addSubChannel = (state, action) => {
  return state.map(item => {
    if (has(item, 'contextUser') && item.contextUser.id === action.payload.id) {
      return {
        ...item,
        subchannels: [...item.subchannels, action.payload.subChannel],
      };
    }
    return item;
  });
};

const addSocialChat = (state, payload) => {
  return [payload, ...state];
};

const updateChatName = (state, action) => {
  return state.map(item => {
    if (
      has(item, 'contextChannel') &&
      get(item, 'contextChannel.channelId') === action.payload.channelId
    ) {
      return {
        ...item,
        contextChannel: {
          ...item.contextChannel,
          channelName: action.payload.channelName,
        },
      };
    }
    if (has(item, 'subchannels')) {
      const subChannels = item.subchannels.map(subChannel => {
        if (subChannel.channelId === action.payload.channelId) {
          return {
            ...subChannel,
            channelName: action.payload.channelName,
          };
        }
        return subChannel;
      });
      return {
        ...item,
        subchannels: subChannels,
      };
    }
    return item;
  });
};

const updateChat = (state, payload) => {
  if (has(payload, 'contextChannel')) {
    return state.map(item => {
      if (
        get(item, 'contextChannel.channelId') ===
        get(payload, 'contextChannel.channelId')
      ) {
        return payload;
      }
      return item;
    });
  }
  if (has(payload, 'contextUser')) {
    return state.map(item => {
      if (get(item, 'contextUser.id') === get(payload, 'contextUser.id')) {
        return payload;
      }
      return item;
    });
  }
  return state;
};

const removeChat = (state, payload) => {
  const { channelId, contextId } = payload;
  return state.filter(item => {
    if (
      has(item, 'contextChannel') &&
      get(item, 'contextChannel.channelId') !== channelId
    ) {
      return item;
    }
    if (has(item, 'subchannels')) {
      if (get(item, 'contextUser.id') === contextId) {
        return {
          ...item,
          subchannels: item.subchannels.filter(
            item => item.channelId !== channelId,
          ),
        };
      }
      return item;
    }
  });
};

const removeContext = (state, payload) => {
  const { contextId } = payload;
  const channel = state.find(item => get(item, 'contextUser.id') === contextId);
  return omit(state, channel);
};

const removeContextUser = (state, payload) => {
  return state.filter(
    item => payload.contextUserId !== get(item, 'contextUser.id'),
  );
};

const updateBlockedStatus = (state, payload) => {
  const { ids } = payload;
  return state.map(item => {
    if (
      has(item, 'contextChannel') &&
      ids.includes(get(item, 'contextChannel.channelId'))
    ) {
      return {
        ...item,
        contextChannel: { ...item.contextChannel, blocked: payload.blocked },
      };
    }
    if (has(item, 'subchannels')) {
      const subChannels = item.subchannels.map(subChannel => {
        if (ids.includes(subChannel.channelId)) {
          return {
            ...subChannel,
            blocked: payload.blocked,
          };
        }
        return subChannel;
      });
      return {
        ...item,
        subchannels: subChannels,
      };
    }
    return item;
  });
};

const reducer = (state = initialState, action) => {
  const { payload, type } = action;

  switch (type) {
    case consts.ADD_ITEMS:
      return addChannels(state, action);
    case consts.CLEAR:
      return initialState;
    case chatConsts.UPDATE_CHANNEL_SUBCHANNELS:
      return addSubChannel(state, action);
    case chatConsts.ADD_SOCIAL_CHAT:
      return addSocialChat(state, payload);
    case chatConsts.UPDATE_CHAT_NAME:
      return updateChatName(state, action);
    case chatConsts.UPDATE_CHANNEL:
      return updateChat(state, payload);
    case chatConsts.REMOVE_SOCIAL_CHANNEL:
      return removeChat(state, payload);
    case chatConsts.REMOVE_CONTEXT:
      return removeContext(state, payload);
    case chatConsts.REMOVE_CONTEXT_USER:
      return removeContextUser(state, payload);
    case chatConsts.UPDATE_BLOCKED_STATUS:
      return updateBlockedStatus(state, payload);
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/redux/board/channels.js